const translations = {
    en: {
        heroTitle: "Welcome to V-Assistant!",
        heroDescription: "V-Assistant saves you time and increases your chances of selling clothing on Vinted. Our extension generates optimized item titles and descriptions using relevant keywords to attract buyers.",
        heroSubtitle: "The ultimate tool for automating your Vinted listings.",
        heroButton: "Download Extension",
      featuresTitle: "Why Choose V-Assistant?",
      features: [
        {
            title: "Save Time Effortlessly",
            description: "Automatically generate item descriptions and titles, saving you valuable time to focus on selling.",
          },
          {
            title: "Optimize Keywords",
            description: "Boost your chances of selling by using AI-generated titles and descriptions packed with trending keywords.",
          },
          {
            title: "Speak Their Language",
            description: "Reach more buyers by listing your items in multiple languages with seamless translations.",
          },
        ],
        // Video Section Translations
       videoTitle: "How to Use V-Assistant",
       videoDescription: "Watch this short tutorial to learn how to use V-Assistant to improve your Vinted listings.",
      pricingTitle: "Affordable Pricing",
      pricingPlans: [
        {
          name: "24-Hour Access",
          description: "Get full access to V-Assistant for 24 hours to enhance your listings effortlessly.",
          price: "$2.50 / €2.50",
        },
      ],
      pricingButton: "Download Extension Here",
      pricingSteps: [
        "Step 1: Open Google Chrome and download the extension.",
        "Step 2: Purchase 24-hour access to start using it instantly.",
      ],
      contactTitle: "Contact Us",
      contactDescription: "Have questions? Use the form below to reach out to us.",
      privacy_policy_title: "Privacy Policy for V-Assistant Chrome Extension",
    privacy_policy_last_updated: "Last Updated: 03.01.2025",
    privacy_policy_intro:
      "At V-Assistant, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use the V-Assistant Chrome Extension.",
    privacy_policy_section_1_title: "1. Information We Collect",
    privacy_policy_section_1_subtitle_a: "a. User-Provided Data",
    privacy_policy_section_1_content_a: "When you use the V-Assistant extension, we may collect the following data:",
    privacy_policy_section_1_content_a_item_1: "Email Address: Used for account validation and subscription management.",
    privacy_policy_section_1_content_a_item_2: "UUID (Unique User Identifier): Generated and stored to uniquely identify your session.",
    privacy_policy_section_1_content_a_item_3: "Token: Used to validate your active subscription status.",
    privacy_policy_section_1_content_a_item_4: "Expiration Date: Tracks the validity of your subscription.",
    privacy_policy_section_1_subtitle_b: "b. Uploaded Images",
    privacy_policy_section_1_content_b:
      "Users may upload images (e.g., for generating product descriptions). These images are processed on our servers but are not stored in our database or any other system after processing.",
    privacy_policy_section_2_title: "2. How We Use Your Information",
    privacy_policy_section_2_content: "We use the collected data for the following purposes:",
    privacy_policy_section_2_content_item_1: "To validate and manage your subscription.",
    privacy_policy_section_2_content_item_2: "To provide the features and functionality of the V-Assistant extension.",
    privacy_policy_section_2_content_item_3: "To process and generate product descriptions from user-uploaded images (without storing the images).",
    privacy_policy_section_3_title: "3. Data Retention",
    privacy_policy_section_3_content: "We store only the following data in our secure database:",
    privacy_policy_section_3_content_item_1: "Email address",
    privacy_policy_section_3_content_item_2: "UUID",
    privacy_policy_section_3_content_item_3: "Token",
    privacy_policy_section_3_content_item_4: "Subscription expiration date",
    privacy_policy_section_4_title: "4. Data Sharing and Disclosure",
    privacy_policy_section_4_content:
      "We do not sell, trade, or share your personal information with third parties, except as required to comply with applicable laws and regulations or respond to legal requests.",
    privacy_policy_section_5_title: "5. Security Measures",
    privacy_policy_section_5_content: "We take your data security seriously and implement the following measures:",
    privacy_policy_section_5_content_item_1: "Encrypted transmission of all data between the extension, backend server, and Stripe.",
    privacy_policy_section_5_content_item_2: "Secure storage of sensitive data using industry-standard encryption.",
    privacy_policy_section_5_content_item_3: "Regular audits and security checks of our infrastructure.",
    privacy_policy_section_6_title: "6. Third-Party Services",
    privacy_policy_section_6_content: "Our extension integrates with the following third-party services:",
    privacy_policy_section_6_content_item_1: "Stripe: For secure payment processing.",
    privacy_policy_section_6_content_item_2: "Vinted: For enhancing your user experience with product descriptions.",
    privacy_policy_section_7_title: "7. Your Rights",
    privacy_policy_section_7_content: "You have the right to:",
    privacy_policy_section_7_content_item_1: "Request access to your personal data.",
    privacy_policy_section_7_content_item_2: "Request deletion of your personal data.",
    privacy_policy_section_7_content_item_3: "Contact us regarding any concerns about your privacy.",
    privacy_policy_section_8_title: "8. Contact Information",
    privacy_policy_section_8_content: "If you have any questions or concerns about this Privacy Policy, please contact us at:",
    privacy_policy_section_9_title: "9. Changes to This Policy",
    privacy_policy_section_9_content:
      "We may update this Privacy Policy from time to time. Any changes will be reflected on this page, and we encourage you to review it periodically.",
    },
    pl: {
        heroTitle: "Witamy w V-Assistant!",
        heroDescription: "V-Assistant oszczędza czas i zwiększa szanse na sprzedaż ubrań na Vinted. Nasze rozszerzenie generuje zoptymalizowane tytuły i opisy przedmiotów, używając odpowiednich słów kluczowych, aby przyciągnąć kupujących.",
        heroSubtitle: "Narzędzie do automatyzacji wystawiania ogłoszeń na Vinted.",
        heroButton: "Pobierz Rozszerzenie",
      featuresTitle: "Dlaczego Wybrać V-Assistant?",
      features: [
        {
            title: "Oszczędzaj Czas",
            description: "Automatycznie generuj opisy i tytuły przedmiotów, oszczędzając czas na sprzedawanie.",
          },
          {
            title: "Słowa Kluczowe",
            description: "Zwiększ szanse na sprzedaż dzięki tytułom i opisom z popularnymi słowami kluczowymi generowanymi przez AI.",
          },
          {
            title: "Mów w Ich Języku",
            description: "Dotrzyj do większej liczby kupujących, wystawiając przedmioty w wielu językach dzięki łatwym tłumaczeniom.",
          },
        ],
    videoTitle: "Jak korzystać z V-Assistant",
    videoDescription: "Obejrzyj ten krótki samouczek i dowiedz się, jak korzystać z V-Assistant, aby ulepszyć swoje oferty Vinted.",
      pricingTitle: "Przystępne Ceny",
      pricingPlans: [
        {
          name: "Dostęp na 24 godziny",
          description: "Uzyskaj pełny dostęp do V-Assistant na 24 godziny i ułatw sobie wystawianie ogłoszeń.",
          price: "9,99 PLN",
        },
      ],
      pricingButton: "Pobierz Rozszerzenie Tutaj",
      pricingSteps: [
        "Krok 1: Otwórz przeglądarkę Google Chrome i pobierz rozszerzenie.",
        "Krok 2: Wykup dostęp na 24 godziny i zacznij korzystać od razu.",
      ],
      contactTitle: "Skontaktuj się z nami",
      contactDescription: "Masz pytania? Skorzystaj z poniższego formularza, aby się z nami skontaktować.",
      privacy_policy_title: "Polityka Prywatności Rozszerzenia Chrome V-Assistant",
privacy_policy_last_updated: "Ostatnia aktualizacja: 03.01.2025",
privacy_policy_intro:
  "W V-Assistant cenimy Twoją prywatność i zobowiązujemy się chronić Twoje dane osobowe. Niniejsza Polityka Prywatności wyjaśnia, w jaki sposób gromadzimy, wykorzystujemy i zabezpieczamy Twoje dane podczas korzystania z rozszerzenia Chrome V-Assistant.",
privacy_policy_section_1_title: "1. Informacje, które zbieramy",
privacy_policy_section_1_subtitle_a: "a. Dane podane przez użytkownika",
privacy_policy_section_1_content_a: "Podczas korzystania z rozszerzenia V-Assistant możemy gromadzić następujące dane:",
privacy_policy_section_1_content_a_item_1: "Adres e-mail: Używany do weryfikacji konta i zarządzania subskrypcją.",
privacy_policy_section_1_content_a_item_2: "UUID (Unikalny Identyfikator Użytkownika): Generowany i przechowywany w celu unikalnego identyfikowania Twojej sesji.",
privacy_policy_section_1_content_a_item_3: "Token: Służy do weryfikacji statusu aktywnej subskrypcji.",
privacy_policy_section_1_content_a_item_4: "Data wygaśnięcia: Śledzi ważność Twojej subskrypcji.",
privacy_policy_section_1_subtitle_b: "b. Przesłane obrazy",
privacy_policy_section_1_content_b:
  "Użytkownicy mogą przesyłać obrazy (np. w celu generowania opisów produktów). Obrazy te są przetwarzane na naszych serwerach, ale nie są przechowywane w naszej bazie danych ani w żadnym innym systemie po przetworzeniu.",
privacy_policy_section_2_title: "2. Jak wykorzystujemy Twoje dane",
privacy_policy_section_2_content: "Zebrane dane wykorzystujemy w następujących celach:",
privacy_policy_section_2_content_item_1: "Aby weryfikować i zarządzać Twoją subskrypcją.",
privacy_policy_section_2_content_item_2: "Aby zapewnić funkcje i działanie rozszerzenia V-Assistant.",
privacy_policy_section_2_content_item_3: "Aby przetwarzać i generować opisy produktów z przesłanych obrazów (bez ich przechowywania).",
privacy_policy_section_3_title: "3. Przechowywanie danych",
privacy_policy_section_3_content: "Przechowujemy jedynie następujące dane w naszej bezpiecznej bazie danych:",
privacy_policy_section_3_content_item_1: "Adres e-mail",
privacy_policy_section_3_content_item_2: "UUID",
privacy_policy_section_3_content_item_3: "Token",
privacy_policy_section_3_content_item_4: "Data wygaśnięcia subskrypcji",
privacy_policy_section_4_title: "4. Udostępnianie i ujawnianie danych",
privacy_policy_section_4_content:
  "Nie sprzedajemy, nie wymieniamy ani nie udostępniamy Twoich danych osobowych stronom trzecim, z wyjątkiem przypadków wymaganych do spełnienia obowiązujących przepisów prawnych lub odpowiedzi na żądania prawne.",
privacy_policy_section_5_title: "5. Środki bezpieczeństwa",
privacy_policy_section_5_content: "Poważnie traktujemy bezpieczeństwo Twoich danych i wdrażamy następujące środki:",
privacy_policy_section_5_content_item_1: "Szyfrowana transmisja wszystkich danych między rozszerzeniem, serwerem backendowym i Stripe.",
privacy_policy_section_5_content_item_2: "Bezpieczne przechowywanie wrażliwych danych przy użyciu standardowych metod szyfrowania.",
privacy_policy_section_5_content_item_3: "Regularne audyty i kontrole bezpieczeństwa naszej infrastruktury.",
privacy_policy_section_6_title: "6. Usługi zewnętrzne",
privacy_policy_section_6_content: "Nasze rozszerzenie integruje się z następującymi usługami zewnętrznymi:",
privacy_policy_section_6_content_item_1: "Stripe: Do bezpiecznego przetwarzania płatności.",
privacy_policy_section_6_content_item_2: "Vinted: W celu ulepszenia doświadczenia użytkownika za pomocą opisów produktów.",
privacy_policy_section_7_title: "7. Twoje prawa",
privacy_policy_section_7_content: "Masz prawo do:",
privacy_policy_section_7_content_item_1: "Żądania dostępu do swoich danych osobowych.",
privacy_policy_section_7_content_item_2: "Żądania usunięcia swoich danych osobowych (np. poprzez anulowanie subskrypcji).",
privacy_policy_section_7_content_item_3: "Skontaktowania się z nami w sprawie wszelkich obaw dotyczących Twojej prywatności.",
privacy_policy_section_8_title: "8. Informacje kontaktowe",
privacy_policy_section_8_content: "Jeśli masz jakiekolwiek pytania lub wątpliwości dotyczące niniejszej Polityki Prywatności, skontaktuj się z nami pod adresem:",
privacy_policy_section_9_title: "9. Zmiany w Polityce Prywatności",
privacy_policy_section_9_content:
  "Możemy aktualizować niniejszą Politykę Prywatności od czasu do czasu. Wszelkie zmiany zostaną odzwierciedlone na tej stronie i zachęcamy do jej regularnego przeglądania.",
    },
  };
  
  export default translations;